import { Button, InputField } from "../../../components/forms";
import { GoDotFill, GoPlus } from "react-icons/go";
import { ListPicker } from "../../../components/generic/ListPicker";
import { usePickerhook } from "../../../hooks/usePickerhook";
import { SearchBar } from "../../../components/generic/SearchBar";
import { Fragment, ReactNode, useEffect, useState } from "react";
import { UserItem } from "../../../components/users/UserItem";
import AdduserModal from "../../../components/users/AddUsers";
import { NoDepartment } from "../../../components/users/NoDepartment";
import AddDepartment from "../../../components/users/AddDepartment";
import { useDeptHook } from "../../../hooks/useDeptHook";
import { DepartmentItem } from "../../../components/users/DepartmentIem";
import { NoEmployee } from "../../../components/users/NoEmployee";
import AddEmployee from "../../../components/Modules/Employees/AddEmployee";
import EmployeeItem from "./EmployeeItem";
import useDepartmentHook from "../../../hooks/useDepartmentHook";
import useEmployeeHook from "../../../hooks/useEmployeeHook";
import usePositionHook from "../../../hooks/usePositionHook";
import { useStateSetter } from "../../../hooks/statehooks/UseStateSettersHook";
import { useStateGetter } from "../../../hooks/statehooks/UseStateGettersHook";
import EmployeeDetailed from "./EmployeeDetailed";
import useLeaveHook from "../../../hooks/useLeaveHook";
import NoLeave from "../../../components/users/NoLeave";
import { Menu, Transition } from "@headlessui/react";
import { BsCalendar, BsGrid, BsPersonFillDash } from "react-icons/bs";
import { FaCalendar } from "react-icons/fa";
import { IoMdMore, IoMdEye } from "react-icons/io";
import { MdCancel, MdOutlineCancel, MdOutlineInfo } from "react-icons/md";
import { LuUser } from "react-icons/lu";
import { useForm } from "react-hook-form";
import { TbDashboard } from "react-icons/tb";
import EmplLeaveList from "./Leave/EmplLeaveList";
import CalenderView from "./Leave/CalenderView";
import DashboardLeaveView from "./Leave/DashboardLeaveView";

const Leaves = () => {
  const departmentPicked = usePickerhook();
  const statusPicked = usePickerhook();
  const positionPicked = usePickerhook();
  const [showadddept, setshowadddept] = useState(false);
  const { selectedOrgEmployees, refresh } = useEmployeeHook();
  const [renderedlist, setrenderedlist] = useState(selectedOrgEmployees);
  const { OrgLeaveTypes, OrgLeaveReq, setOrgLeaveReq } = useLeaveHook();
  const { selectedOrgDepts } = useDepartmentHook();
  const { allorgPositions } = usePositionHook();
  const { OrgLeavePolicies, getOrgLeaveTypes } = useLeaveHook();
  const tabs = [
    { icon: <BsGrid className=" inline mr-1" />, title: "Grid" },
    { icon: <BsCalendar className=" inline  mr-1 " />, title: "Calender" },
    { icon: <TbDashboard className=" inline  mr-1" />, title: "Dashboard" },
  ];
  const tabViews = [
    <EmplLeaveList
      refresh={getOrgLeaveTypes}
      leaves={OrgLeaveReq}
      isAdminview={true}
      setshowaddleavemodal={() => {}}
    />,
    <CalenderView
      refresh={getOrgLeaveTypes}
      leaves={OrgLeaveReq}
      setshowaddleavemodal={() => {}}
    />,
    <DashboardLeaveView />,
  ];
  const [selectedTabview, setselectedTabview] = useState<JSX.Element>(
    tabViews[0]
  );
  const ActionItem2 = ({ title, icon, key_ }: any) => (
    <div
      onClick={() => {
        setselectedTabview(tabViews[key_]);
        setselectedTab(title);
      }}
      className={`m-1 rounded-[8px]    p-2  font-semibold ${
        selectedTab == title
          ? "bg-textbg text-white"
          : " bg-faintBlue text-blueGray "
      }`}
    >
      <p className="  cursor-pointer text-xs flex justify-center items-center ">
        {icon}
        {title}
      </p>
    </div>
  );
  const [selectedTab, setselectedTab] = useState(tabs[0].title);
   const { authuser } = useStateGetter();
  const { setselectedEmpl, setSidebarRenderView, setShowModal } =useStateSetter();
  const [entered, setentered] = useState("");
  const onChange = (e: string) => {
    setentered(e);
  };
  useEffect(() => {
    setrenderedlist(OrgLeaveReq);
  }, [OrgLeaveReq]);

  useEffect(() => {
    setselectedTabview(tabViews[0]);
    setselectedTab(tabs[0].title);
  }, [OrgLeavePolicies, OrgLeaveTypes]);
  useEffect(() => {
    setrenderedlist(
      OrgLeaveReq.filter((t) => statusPicked.pickedRole.code.includes(t.status))
    );
  }, [statusPicked.pickedRole]);
  useEffect(() => {
    setrenderedlist(
      selectedOrgEmployees.filter(
        (t) => t.positionID == positionPicked.pickedRole.code
      )
    );
  }, [positionPicked.pickedRole]);
  useEffect(() => {
    if (authuser.isEmployee) {
      selectedOrgEmployees.map((it: any) => {
        if (it.workEmail == authuser.email) {
          setselectedEmpl(it);
          setSidebarRenderView(<EmployeeDetailed id={it.id} />);
        }
      });
    }
  }, [selectedOrgEmployees]);
  return (
    <div className="w-full pr-20  flex  ">
      {showadddept && <AddEmployee refresh={refresh} show={setshowadddept} />}
      <div className={` p-6 bg-white  h-[100vh]  w-full  rounded-[20px]`}>
        <div className="  w-full  flex justify-start gap-4 items-center  ">
          <p className="text-textbg font-medium text-sm mb-2 text-[16px] bg-white">
            Leave Management ({OrgLeaveReq.length})
          </p>

          <div className="border border-gray-300 p-1 flex rounded-md  ">
            {tabs.map((it, key) => (
              <ActionItem2 key_={key} {...it} />
            ))}
          </div>
        </div>
        <div className="w-full flex justify-between items-center">
          <div className="flex  gap-4">
            <ListPicker
              hook={statusPicked}
              notitle
              title="All status"
              list={[
                { code: "pending", name: "Pending" },
                { code: "approved", name: "Approved" },
                { code: "cancelled", name: "Cancelled" },
                { code: "rejected", name: "Rejected" },
              ]}
            />
            <ListPicker
              hook={departmentPicked}
              notitle
              title="All leave types"
              list={OrgLeaveTypes.map((item: any) => {
                return { name: item.leaveName, code: item.id };
              })}
            />
            <ListPicker
              hook={departmentPicked}
              notitle
              title="Department"
              list={
                selectedOrgDepts
                  ? selectedOrgDepts?.map((i) => {
                      return { name: i.deptName, code: i.id };
                    })
                  : []
              }
            />
            <ListPicker
              hook={positionPicked}
              notitle
              title="Position"
              list={
                allorgPositions
                  ? allorgPositions?.map((i: any) => {
                      return { name: i.positionTitle, code: i.id };
                    })
                  : []
              }
            />
          </div>
        </div>
        <hr />

        {/* {OrgLeaveReq.length > 0 ? (
         
<></>        ) : (
          <div className="flex justify-center self-center items-center">
            <NoLeave add={setshowadddept} />{" "}
          </div>
        )} */}

        {selectedTabview}
      </div>
    </div>
  );
};
export { Leaves };

const todatestring = (datestring: string) => {
  var date = new Date(datestring);

  return date.toDateString();
};

const LeaveItem = ({ item }: any) => {
  const [startdate, setstartdate] = useState("");
  const { showModal, setShowModal } = useStateSetter();
  const [enddate, setenddate] = useState("");
  const { selectedOrgDepts } = useDepartmentHook();
  const { control, getValues } = useForm();
  const { RejectLeave, ApproveLeave } = useLeaveHook();
  const { allorgPositions } = usePositionHook();
  useEffect(() => {
    var enddate_ = new Date(item.endDate);
    var statdate_ = new Date(item.startDate);

    setenddate(enddate_.toDateString());
    setstartdate(statdate_.toDateString());
  }, []);
  function getduration() {
    var date1 = new Date(item.startDate);
    var date2 = new Date(item.endDate);

    const timeDifference = date2.getTime() - date1.getTime(); // Difference in milliseconds
    const daysDifference = timeDifference / (1000 * 60 * 60 * 24); // Convert to day
    return Math.round(daysDifference);
  }

  const RejectLeaveModal = () => {
    return (
      <div className="flex flex-col justify-center w-full items-center">
        <MdOutlineInfo size={30} className="text-primary my-2" />

        <p className="font-semibold"> Reject Leave Request </p>
        <small className="font-light text-gray-500   text-center">
          You are about to reject this leave request. Please leave a note
          explaining the reason for the rejection.
        </small>
        <div className="w-full">
          <InputField
            name="reason"
            title="Reason"
            placeholder={"Reason for rejection"}
            isTextArea
            control={control}
          />
        </div>

        <div className=" gap-6 w-full flex ">
          <Button
            outlined
            disabled={false}
            text="Cancel"
            onBtnClick={() => {
              setShowModal(false);
            }}
          />
          <Button
            disabled={false}
            text="Reject"
            onBtnClick={async () => {
              await RejectLeave(item.id, getValues("reason"));
            }}
          />
        </div>
      </div>
    );
  };

  const ViewLeaveModal = () => {
    return (
      <div className="flex flex-col justify-start w-full items-start">
        <p className="font-semibold w-full flex justify-between text-sm">
          Leave Request
          <MdOutlineCancel
            onClick={() => setShowModal(false)}
            size={20}
            className="text-gray-400"
          />
        </p>
        <p className="text-sm w-full my-2">
          {" "}
          <GoDotFill
            size={15}
            className={`${
              item.status == "pending" || item.status == "rejected"
                ? "text-[#F79009]"
                : ""
            }  ${item.status == "approved" ? "text-green-400" : ""} inline `}
          />
          {item.status}
        </p>

        {item.status != "pending" && (
          <p className="w-full flex  flex-col text-xs">
            <span className="font-medium ">Reason</span>
            <span className="font-light rounded mt-2 bg-gray-100 p-2">
              Note:{item.actionedComment}{" "}
            </span>
          </p>
        )}
        <div className="flex mt-2 flex-col w-full">
          <LuUser
            className="  p-2 rounded-full bg-faintBlue  text-textbg"
            size={50}
          />{" "}
          <div className="m-2">
            <p className="font-semibold text-sm">
              {item.employee.firstName} {item.employee.lastName}
            </p>
            <p className="font-light text-xs">{item.employee.workEmail} </p>
            <p className="font-light   ">
              <span className="bg-faint text-xs mx-1 rounded">
                {" "}
                {
                  allorgPositions.filter(
                    (ik: any) => ik.id == item.employee.positionID
                  )[0]?.positionTitle
                }
              </span>

              <span className="bg-faint text-xs mx-1 rounded">
                {" "}
                {
                  selectedOrgDepts.filter(
                    (ik: any) => ik.id == item.employee.deptID
                  )[0]?.deptName
                }
              </span>
            </p>
          </div>
          <div className="p-3 bg-gray-100 px-4 w-full rounded">
            <p className="w-full flex justify-between text-xs">
              <span className="font-medium ">Leave type</span>
              <span className="font-medium">{item.leaveType.leaveName}</span>
            </p>
            <p className="w-full flex justify-between text-xs">
              <span className="font-medium ">Start Date</span>
              <span className="font-medium">
                {todatestring(item.startDate)}
              </span>
            </p>
            <p className="w-full flex justify-between text-xs">
              <span className="font-medium ">End Date</span>
              <span className="font-medium">{todatestring(item.endDate)}</span>
            </p>
            <p className="w-full flex justify-between text-xs">
              <span className="font-medium ">Duration</span>
              <span className="font-medium">{getduration()} day(s)</span>
            </p>
            <p className="w-full flex  flex-col text-xs">
              <span className="font-medium ">Note</span>
              <span className="font-light rounded mt-2 bg-white p-2">
                Note:{item.reason}{" "}
              </span>
            </p>
          </div>
          {item.status == "pending" ? (
            <div className=" gap-6 w-full flex ">
              <Button
                outlined
                disabled={false}
                text="Reject"
                onBtnClick={async () => {
                  showModal("", "", <></>, <RejectLeaveModal />);
                }}
              />
              <Button
                disabled={false}
                text="Approve"
                onBtnClick={async () => {
                  await ApproveLeave(item.id);
                }}
              />
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  };

  return (
    <div className=" px-2 py-6 text-xs  rounded-[10px] border border-gray-300  flex justify-between ">
      <div>
        <p className="font-semibold my-2 ">
          {item.employee.firstName} {item.employee.lastName}
        </p>
        <p className="flex justify-center text-gray-600 items-center text-[10px]">
          <FaCalendar size={10} className="  inline" />
          {startdate}-{enddate}{" "}
          <BsPersonFillDash size={10} className=" inline" />
          {item.leaveType.leaveName}{" "}
          <GoDotFill
            size={15}
            className={`${
              item.status == "pending" || item.status == "rejected"
                ? "text-[#F79009]"
                : ""
            }  ${item.status == "approved" ? "text-green-400" : ""} inline `}
          />
          {item.status}
        </p>
      </div>
      <Menu as="div" className={`relative my-2 `}>
        <Menu.Button className="   w-full       ">
          <IoMdMore size={20} className="text-textbg " />
        </Menu.Button>

        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items
            onClick={() => {}}
            className="origin-top-left z-10 absolute left-0 mt-2 rounded-sm shadow-md p-1 bg-white w-full  max-h-[200px] min-w-[150px]   overflow-x-hidden overflow-y-scroll ring-1 ring-black ring-opacity-5 focus:outline-none"
          >
            <Menu.Item>
              <p
                onClick={() => {
                  showModal("", "", <></>, <ViewLeaveModal />);
                }}
                className=" text-xs font-light w-full text-black p-3 m-2 cursor-pointer truncate hover:bg-customGray "
              >
                <IoMdEye className="inline" /> View
              </p>
            </Menu.Item>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
};
